import { render, staticRenderFns } from "./management-library-agreement-type-view.vue?vue&type=template&id=4b95bd1b"
import script from "./management-library-agreement-type-view.vue?vue&type=script&lang=js"
export * from "./management-library-agreement-type-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports